export let productApiCalls = {};

function fetchProductRoute(url) {
  return new Promise(resolve => {
    if (productApiCalls[url]) {
      resolve(productApiCalls[url]);
    } else {
      callApi(url).then(result => {
        productApiCalls[url] = result;
        resolve(result);
      })
    }
  })
}

function callApi(url) {
  return new Promise(resolve => {
    fetch(url, {
      method: 'get',
      headers: {
        'x-api-key': process.env.VUE_APP_API_KEY_PRODUCTS,
        'client-key': process.env.VUE_APP_CLIENT_KEY_PRODUCTS
      }
    }).then(response => response.json()).then(response => {
      resolve(response)
    })
  })
}

function sortResponse(data) {
  return sortHelper(data).map(item => {
    item.pre_conditions = sortHelper(item.pre_conditions);
    return item;
  });
}

function sortHelper(data) {
  return data.sort((a, b) => {
    if (a.name.toLowerCase() === 'sonstiges') return 1;
    if (b.name.toLowerCase() === 'sonstiges') return -1;
    return a.name.localeCompare(b.name);
  });
}

export {
  fetchProductRoute,
  sortResponse
}
